import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ItemSliding } from 'ionic-angular';

import { DatabaseProvider } from '../../providers/database/database';

import { DeliveryAddPage } from '../delivery-add/delivery-add';
import { DeliveryItem } from './deliveryitem';

@IonicPage()
@Component({
  selector: 'page-delivery',
  templateUrl: 'delivery.html'
})
export class DeliveryPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,
                public dbProvider: DatabaseProvider) {
      
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DeliveryPage');
  }

  addDelivery(){
    console.log('addDelivery() called...');
    this.navCtrl.push(DeliveryAddPage, {});
  }

  markAsPaid(slidingItem: ItemSliding, aDeliveryItem: DeliveryItem){
    this.dbProvider.markDeliveryItemAsPaid(aDeliveryItem);
    slidingItem.close();
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/delivery/delivery.ts